import Progbar from '@pages/GoalsPage/components/Progbar';

import { Title, Text, Ul, ProgbarContainer } from '../OnboardingStyles';

const Connect = () => (
  <>
    <ProgbarContainer>
      <Progbar currentStep={2} totalSteps={5} />
    </ProgbarContainer>
    <Title>📩 Connect Your Calendar & Email</Title>
    <br />
    <Text>By connecting your calendar and email, Jamie can:</Text>
    <Ul>
      <br />
      <li>
        Identify patterns, blockers, and strategic issues from your meetings and communications
      </li>
      <li>Highlight open questions, risks, and opportunities across your workflow</li>
      <li>Prioritize what matters most based on your goals</li>
      <li>Keep you focused with intelligent follow-ups and decision support</li>
    </Ul>
    <Text>
      <br />
      🔐 Your data is secure and used solely to support your strategic workflow - nothing is shared
      or exposed.
    </Text>
  </>
);

export default Connect;
